// Care coordination subsection form field enum
export enum CareCoordinationFormField {
  CARE_COORDINATION_PREVIOUS_APPOINTMENTS = 'medicalBackground/careCoordination/previousAppointments',
  CARE_COORDINATION_FUTURE_APPOINTMENTS = 'medicalBackground/careCoordination/futureAppointments',
  CARE_COORDINATION_CARE_TEAM_COORDINATION = 'medicalBackground/careCoordination/careTeamCoordination',
  CARE_COORDINATION_ORDERS_FOR_TREATMENT = 'medicalBackground/careCoordination/ordersForTreatment',
  CARE_COORDINATION_DATE_OF_VERBAL_COMMUNICATION = 'medicalBackground/careCoordination/dateOfVerbalCommunication'
}
